import { Site } from '@envato/foundation-types'
import get from 'lodash-es/get'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import pushHistory from '../../../../common/utils/location/pushHistory'
import { getMinutesSecondsTime } from '../../../../common/utils/time'
import ChevronRightIcon from '../../../components/icons/chevronRight'

import * as styles from './filtersRange.module.css'

interface IProps extends RouteComponentProps<any> {
  paramName: string
  name: string
  prefix?: string
  type?: string
  range?: any
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

interface IState {
  min?: number | string
  max?: number | string
}

const dataTypes: any = {
  time: getMinutesSecondsTime,
  number: (value: string): number => parseFloat(value)
}

class FiltersRange extends React.Component<IProps, IState> {
  private paramMin: string
  private paramMax: string
  private placeholder: any

  constructor(props: IProps) {
    super(props)
    const { locationParams, paramName, range } = props

    this.paramMin = `${paramName}_min`
    this.paramMax = `${paramName}_max`

    const min = locationParams && locationParams[this.paramMin]
    const max = locationParams && locationParams[this.paramMax]

    this.placeholder = {
      min: this.parseValue(range.min),
      max: this.parseValue(range.max)
    }

    this.state = {
      min: this.parseValue(min),
      max: this.parseValue(max)
    }

    this.onEnter = this.onEnter.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  public onSubmit() {
    const { locationParams, history, makeSearchLink } = this.props

    const nextQuery = {
      ...locationParams,
      [this.paramMin]: `${this.parseValue(this.state.min)}`,
      [this.paramMax]: `${this.parseValue(this.state.max)}`
    }
    delete nextQuery.page

    if (!this.state.min) {
      delete nextQuery[this.paramMin]
    }

    if (!this.state.max) {
      delete nextQuery[this.paramMax]
    }

    pushHistory(history, makeSearchLink(nextQuery) + '#content')
  }

  public onEnter(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  public componentWillReceiveProps(nextProps: IProps) {
    const { locationParams, range } = nextProps

    if (locationParams[this.paramMin] !== this.state.min) {
      this.setState({
        min: this.parseValue(locationParams[this.paramMin]) || ''
      })
    }

    if (locationParams[this.paramMax] !== this.state.max) {
      this.setState({
        max: this.parseValue(locationParams[this.paramMax]) || ''
      })
    }

    this.placeholder = {
      min: this.parseValue(range.min),
      max: this.parseValue(range.max)
    }
  }

  public render() {
    return (
      <div className={styles.inputsContainer}>
        <div className={styles.inputWrapper}>
          {this.getPrefix()}
          <input
            aria-label={`Minimum ${this.props.name}`}
            min="0"
            type="text"
            name={`Minimum ${this.props.name}`}
            className={styles.input}
            value={this.state.min}
            placeholder={this.placeholder.min}
            onChange={event => {
              this.onRangeChange('min', event)
            }}
            onKeyPress={this.onEnter}
          />
        </div>
        <span className={styles.spacer}>-</span>
        <div className={styles.inputWrapper}>
          {this.getPrefix()}
          <input
            aria-label={`Maximum ${this.props.name}`}
            min="0"
            type="text"
            name={`Maximum ${this.props.name}`}
            className={styles.input}
            value={this.state.max}
            placeholder={this.placeholder.max}
            onChange={event => {
              this.onRangeChange('max', event)
            }}
            onKeyPress={this.onEnter}
          />
        </div>
        <button
          type="button"
          className={styles.buttonFilter}
          onClick={this.onSubmit}
        >
          <ChevronRightIcon width="8" height="12" />
        </button>
      </div>
    )
  }

  private onRangeChange(
    minOrMax: 'min' | 'max',
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const inputValue = get(event, 'target.value', '0')
    const outputValue =
      this.props.type === 'number'
        ? this.removeNonNumbers(inputValue)
        : this.removeNonNumbersExceptColons(inputValue)
    this.setState({ [minOrMax]: outputValue })
  }

  private removeNonNumbers(value: string) {
    return value.replace(/\D/g, '')
  }

  private removeNonNumbersExceptColons(value: string) {
    return value.replace(/[^:0-9]/g, '')
  }

  private parseValue(value: string | number | undefined): string {
    if (typeof value === 'undefined') {
      return ''
    }

    const { type = 'number' } = this.props

    return dataTypes[type](value)
  }

  private getPrefix() {
    return this.props.prefix ? (
      <span className={styles.prefix}>{this.props.prefix}</span>
    ) : null
  }
}

export const FiltersRangeComponent = FiltersRange
export default withRouter(FiltersRange)
